import React, { useEffect } from 'react';
import { getOrder } from '../actions/orderActions';
import { connect } from 'react-redux';
import { Row, Col, Container, Badge } from 'reactstrap';
import moment from 'moment';
import Spinner from './Spinner';
import { useHistory, useParams } from 'react-router-dom';

const OrderDetails = ({ orders, getOrder }: any) => {
  const history = useHistory();
  const { orderid } = useParams() as any as any;

  useEffect(() => {
    getOrder(orderid);
  }, []);

  const handleClick = () => {
    history.push('/dashboard/addresses');
  };

  const handleSingleOrder = (item) => {
    history.push(`/dashboard/order-details/${item._id}`);
  };

  let SubTotal;
  if (orders.order.products) {
    SubTotal =
      Math.round(
        orders.order.products
          .map((eachItem) => eachItem.productQuantity * eachItem.productPrice)
          .reduce((total, currentValue) => total + currentValue) * 100
      ) / 100;
  }

  let total = orders.order.total / 100;

  let discount;

  if (orders.order.coupon) {
    if (SubTotal >= orders.order.coupon.minimumSpend) {
      if (orders.order.coupon.isPercent) {
        discount = (SubTotal / 100) * orders.order.coupon.amount;
      } else {
        discount = orders.order.coupon.amount;
      }
    }
  }

  return (
    <div>
      {orders.fetching ? (
        <div className="text-center">
          <Container>
            <Row>
              <Col className="my-5">
                <Spinner />
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        Object.keys(orders.order).length > 0 && (
          <Container className="my-5 ">
            <Row className="my-3 border-bottom ">
              <Col>
                <h4 style={{ fontWeight: 'bolder' }}>Order Details</h4>
              </Col>
            </Row>
            <Row>
              <Col sm="8">
                <p className="my-2 px-2 text-muted">
                  Order Status:{' '}
                  <Badge
                    style={{ fontSize: '100%' }}
                    color={orders.order.orderStatus === 'Processing' ? 'warning' : 'success'}
                  >
                    {orders.order.orderStatus}
                  </Badge>
                </p>
                <p className="my-2 px-2 text-muted">Order Number : {orderid.toUpperCase()}</p>
                <table className="table">
                  <thead className="table-borderless">
                    <tr>
                      <th scope="col">PRODUCT</th>
                      <th></th>
                      <th scope="col">QTY</th>
                      <th scope="col">PRICE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.order.products.map((item) => (
                      <tr key={item.productId}>
                        <td style={{ width: '100px' }}>
                          <img
                            src={item.productImage}
                            alt={item.productName}
                            className="img-fluid"
                          />
                        </td>
                        <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                          {' '}
                          {item.productName}
                        </td>
                        <td style={{ verticalAlign: 'middle' }} className="font-weight-bold">
                          {item.productQuantity}
                        </td>
                        <td
                          style={{ verticalAlign: 'middle', width: '100px' }}
                          className="font-weight-bold text-muted"
                        >
                          $
                          {(
                            Math.round(item.productQuantity * item.productPrice * 100) / 100
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
              <Col sm="4">
                <Row>
                  <Col className="border py-3 mx-1">
                    {orders.order.shippingType === 'pickup' ? (
                      <React.Fragment>
                        <h5>Pick Up</h5>
                        <p>
                          {orders.order.firstName} {orders.order.lastName}
                        </p>
                        <p>Phone Number: {orders.order.phoneNumber}</p>
                        <p>Pick up date: {moment(orders.order.pickUpDate).format('L')}</p>
                        <p>Pick up time: {orders.order.pickUpTime / 3600}:00 </p>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <h5>Delivery Address</h5>
                        <p>
                          {orders.order.firstName} {orders.order.lastName}
                        </p>
                        <p>Phone Number: {orders.order.phoneNumber}</p>
                        <p>{orders.order.address}</p>
                        <p>
                          {orders.order.suburb.toUpperCase()} VIC {orders.order.postcode}
                        </p>
                        {orders.order.shippingDate && (
                          <p className="text-success">
                            Shipping Date: {moment(orders.order.shippingDate).format('LL')}
                          </p>
                        )}
                      </React.Fragment>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col className="border py-3 mx-1 my-1">
                    <h5>Order Total</h5>
                    <div className="border-bottom py-2">
                      <p>
                        SubTotal <span className="float-right">AU ${SubTotal.toFixed(2)}</span>
                      </p>
                      <p>
                        Shipping{' '}
                        <span className="float-right">
                          {orders.order.shippingFee !== 0
                            ? 'AU $' + orders.order.shippingFee.toFixed(2)
                            : 'Free'}
                        </span>
                      </p>
                      {orders.order.coupon && discount !== undefined && (
                        <React.Fragment>
                          <p>
                            Discount{' '}
                            <span className="float-right">
                              {orders.order.coupon.isPercent ? '%' : 'AU $'}
                              {orders.order.coupon.amount}
                            </span>
                          </p>
                          <p className="text-danger">
                            Discount Applied{' '}
                            <span className="float-right text-danger">
                              - AU ${discount.toFixed(2)}
                            </span>
                          </p>
                        </React.Fragment>
                      )}
                    </div>
                    <h1>
                      Total <span className="float-right">AU ${total.toFixed(2)}</span>
                    </h1>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        )
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
  cart: state.cart,
  fullPageLoading: state.fullPageLoading,
  orders: state.orders,
});

export default connect(mapStateToProps, { getOrder })(OrderDetails);
